// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.question-prompt[data-v-1929da00] {\n  color: #000;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.prompt-title[data-v-1929da00] {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28px;\n}\n.prompt-description[data-v-1929da00] {\n  color: var(--opacity-black-600, rgba(18, 18, 20, 0.6));\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
